export const SET_CUSTOMER_NOTES = 'SET_CUSTOMER_NOTES';
